
import React from "react";
import { TSPEvent } from "@/types/tsp";
import { format } from "date-fns";

interface GameContentProps {
  game: TSPEvent;
  className: string;
  textColor: string;
}

export const GameContent: React.FC<GameContentProps> = ({ game, className, textColor }) => {
  const isLive = game.meta.event_status === "Live";

  return (
    <div className={`game-item ${className}`} style={{ transform: 'none' }}>
      <div className="flex items-center space-x-8">
        <div className="flex items-center space-x-3">
          <img 
            src={game.meta.event_away_team_large_logo}
            alt={game.meta.event_away_team}
            className="h-7 w-7 object-contain"
          />
          <div className="text-[17px] font-[Helvetica]" style={{ color: textColor }}>
            {game.meta.event_away_team}
          </div>
        </div>
        <span className="text-[17px] font-[Helvetica]" style={{ color: textColor }}>vs</span>
        <div className="flex items-center space-x-3">
          <img 
            src={game.meta.event_home_team_large_logo}
            alt={game.meta.event_home_team}
            className="h-7 w-7 object-contain"
          />
          <div className="text-[17px] font-[Helvetica]" style={{ color: textColor }}>
            {game.meta.event_home_team}
          </div>
        </div>
        {isLive && (
          <div className="flex items-center space-x-3">
            <div className="animate-pulse w-2 h-2 rounded-full bg-red-500" />
            <span className="text-[17px] font-[Helvetica] text-red-500">LIVE NOW</span>
          </div>
        )}
        {!isLive && (
          <span className="text-[17px] font-[Helvetica]" style={{ color: textColor }}>
            - {format(new Date(`${game.meta.event_date} ${game.meta.event_time}`), 'EEEE MM/dd @ h:mm a')} CST
          </span>
        )}
      </div>
    </div>
  );
};
